import { render, staticRenderFns } from "./refundModal.vue?vue&type=template&id=988d8900&scoped=true"
import script from "./refundModal.vue?vue&type=script&lang=js"
export * from "./refundModal.vue?vue&type=script&lang=js"
import style0 from "./refundModal.vue?vue&type=style&index=0&id=988d8900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "988d8900",
  null
  
)

export default component.exports